import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { useTranslation } from "../hooks/useTranslation";
import { HUB_PAGE_BG, hub } from "../components/hub/hubSurface";

const AboutPage: React.FC = () => {
  const { t } = useTranslation();
  const siteUrl = import.meta.env?.VITE_SITE_URL || "https://lenz3.com";

  return (
    <Layout
      title={t("about.pageTitle")}
      description={t("about.pageDescription")}
      canonical={`${siteUrl}/about`}
    >
      <div className="min-h-screen pb-16" style={{ background: HUB_PAGE_BG }}>
        <article className="max-w-3xl mx-auto px-4 md:px-6 pt-10">
          <h1 className={`text-2xl md:text-3xl font-bold tracking-tight ${hub.ink}`}>
            {t("about.heading")}
          </h1>
          <p className={`mt-4 text-sm md:text-base leading-8 ${hub.mute}`}>{t("about.p1")}</p>
          <h2 className={`mt-8 text-lg font-bold ${hub.ink}`}>{t("about.h2Players")}</h2>
          <p className={`mt-3 text-sm md:text-base leading-8 ${hub.mute}`}>{t("about.p2")}</p>
          <h2 className={`mt-8 text-lg font-bold ${hub.ink}`}>{t("about.h2News")}</h2>
          <p className={`mt-3 text-sm md:text-base leading-8 ${hub.mute}`}>{t("about.p3")}</p>
          <div className="mt-8 flex flex-wrap gap-2">
            <Link to="/transfers" className={hub.btnPrimary}>
              {t("hub.ctaTransfers")}
            </Link>
            <Link to="/news" className={hub.btnGhost}>
              {t("hub.ctaNews")}
            </Link>
          </div>
        </article>
      </div>
    </Layout>
  );
};

export default AboutPage;
